import React, {useState} from 'react';
import {Box, Button, Chip, CircularProgress, Typography} from '@mui/material';
import {toastHelper} from '../../../utils/toast-helper';
import {useLazyGetCalibrationQuery} from '../../../modules/simulations/simulations.api';
import {CARD_SX} from '../interventions/v2/primitives.js';
import {
    appliquerCalibration, marqueSection, paramsCalibration, pastillesProposition, peutAppliquer, texteEcartees, texteSource,
} from './calibrationRules';

/**
 * Calibration des curseurs de temps depuis l'historique (lot 5, B-2 / B-3), dans « Réglages avancés » du wizard et du volet.
 * Le bouton interroge l'API et affiche la proposition AVEC sa source ; rien n'est écrit dans le formulaire avant « Appliquer ».
 */
function BlocCalibration({formik, patrimoine}) {
    const [charger, {isFetching}] = useLazyGetCalibrationQuery();
    const [calibration, setCalibration] = useState(null);
    const marque = marqueSection(formik.values);

    const calibrer = async () => {
        try {
            setCalibration(await charger(paramsCalibration(patrimoine)).unwrap());
        } catch (e) {
            toastHelper.handleError(e, "La calibration n'a pas pu être calculée.");
        }
    };
    const appliquer = () => {
        formik.setValues(appliquerCalibration(formik.values, calibration));
        setCalibration(null);
    };
    const ecartees = calibration ? texteEcartees(calibration) : null;

    return (
        <Box sx={{mb: 2}} data-testid="bloc-calibration">
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap'}}>
                <Button variant="outlined" color="primary" size="small" onClick={calibrer} disabled={isFetching || !patrimoine}
                        startIcon={isFetching ? <CircularProgress size={16} color="inherit"/> : null}
                        sx={{borderRadius: 999, textTransform: 'none', fontWeight: 700}}>
                    Calibrer depuis l'historique
                </Button>
                {marque && <Chip size="small" label={marque} data-testid="marque-calibre" sx={{bgcolor: '#EDF4DB', color: '#5C8316', fontWeight: 700}}/>}
            </Box>

            {calibration &&
                <Box sx={{...CARD_SX, mt: 1.5, p: 1.5}} data-testid="carte-calibration">
                    <Typography sx={{fontSize: 13, color: '#1B1F24'}}>{texteSource(calibration)}</Typography>
                    {ecartees && <Typography variant="caption" sx={{display: 'block', color: '#8A929C'}}>{ecartees}</Typography>}
                    {peutAppliquer(calibration) &&
                        <Box sx={{display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 1}}>
                            {pastillesProposition(calibration.proposition).map((t) =>
                                <Chip key={t} size="small" label={t} sx={{bgcolor: '#EEF1F4', fontWeight: 600}}/>)}
                        </Box>}
                    <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5}}>
                        <Button size="small" color="primary" onClick={() => setCalibration(null)} sx={{textTransform: 'none'}}>Ignorer</Button>
                        {peutAppliquer(calibration) &&
                            <Button size="small" variant="contained" onClick={appliquer}
                                    sx={{borderRadius: 999, textTransform: 'none', fontWeight: 700, bgcolor: '#213067', '&:hover': {bgcolor: '#0F2D69'}}}>
                                Appliquer
                            </Button>}
                    </Box>
                </Box>}
        </Box>
    );
}

export default BlocCalibration;
